import Bowser from 'bowser'
import { useEffect, useState } from 'react'
import {
  // UUIDGenerator,
  getLocalStorage,
  setLocalStorage
} from '~/src/utils/global'

export const LOCAL_STORAGE_KEY = 'data'
export const LOCAL_STORAGE_UUID = 'device_id'

export type BrowserInfoType = {
  deviceId?: string
  browser?: string
  os?: string
  type?: string
  browserVersion?: string
  osVersion?: string
  locationAccess?: boolean
  message?: string
  error?: boolean
}

export const fetchBrowserLocation = async () => {
  try {
    const position: GeolocationPosition = await new Promise(
      (resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject)
      }
    )
    const { coords } = position
    const { latitude, longitude } = coords
    return { latitude, longitude }
  } catch (e) {
    return { error: 'Fetch device location failed' }
  }
}

export const fetchDeviceDetails = () => {
  const { navigator: { userAgent } = {} } = window
  if (!userAgent) {
    return { error: 'Fetch Device Info failed' }
  }

  const browserDetails = Bowser.parse(userAgent)
  const { browser, os } = browserDetails

  let deviceId = getLocalStorage(LOCAL_STORAGE_UUID) as string

  if (!deviceId) {
    deviceId = crypto.randomUUID()
    setLocalStorage(LOCAL_STORAGE_UUID, deviceId)
  }

  return {
    deviceId,
    browser: browser.name,
    os: os.name,
    browserVersion: browser.version,
    osVersion: os.version || 'os version not available'
  }
}

export const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine)

  useEffect(() => {
    const handleOnline = () => setIsOnline(true)
    const handleOffline = () => setIsOnline(false)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    // Clean up event listeners on component unmount
    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  return isOnline
}
